import { useCallback, useEffect, useState } from "react";

const DEFAULT_STORAGE_KEY = "relevance_review_provider_filter";

interface UseProviderFilterOptions {
  storageKey?: string;
}

export function useProviderFilter(options?: UseProviderFilterOptions) {
  const storageKey = options?.storageKey ?? DEFAULT_STORAGE_KEY;
  const [providerIds, setProviderIdsState] = useState<string[]>([]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed) && parsed.every((id) => typeof id === "string")) {
          setProviderIdsState(parsed);
        }
      }
    } catch (error) {
      console.warn("Failed to parse provider filter from localStorage:", error);
      setProviderIdsState([]);
    }
  }, [storageKey]);

  const setProviderIds = useCallback(
    (ids: string[]) => {
      setProviderIdsState(ids);
      if (ids.length === 0) {
        localStorage.removeItem(storageKey);
        return;
      }
      localStorage.setItem(storageKey, JSON.stringify(ids));
    },
    [storageKey],
  );

  const clearProviderIds = useCallback(() => {
    setProviderIdsState([]);
    localStorage.removeItem(storageKey);
  }, [storageKey]);

  return {
    providerIds,
    setProviderIds,
    clearProviderIds,
  };
}
